<template>
  <div id="admin-tests">
    <!-- modals -->
    <!-- modal: change user name -->
    <modal
      v-if="testers != null && testers[states.selectTester] != null"
      id="change-name-modal"
      :title="
        'Change name of user ' +
          testers[states.selectTester].name +
          '(' +
          testers[states.selectTester].id +
          ') to'
      "
    >
      <div class="container">
        <div class="row">
          <div class="col-10">
            <input
              type="text"
              class="form-control"
              maxlength="50"
              placeholder="Type the new name here"
              v-model="inputUserName"
            />
          </div>
          <div class="col-2">
            <button
              type="button"
              class="btn btn-outline-dark"
              @click="
                localEventHandler('click-change-name-ok', {
                  tester: testers[states.selectTester]
                })
              "
            >
              OK
            </button>
          </div>
        </div>
      </div>
    </modal>
    <!-- modal: assign test -->
    <modal
      v-if="testers != null && testers[states.selectTester] != null"
      id="assign-modal"
      :title="
        'Assign tests to: ' +
          testers[states.selectTester].name +
          '(' +
          testers[states.selectTester].id +
          ')'
      "
      size="sm"
    >
      <div class="containers">
        <div class="form-group row">
          Enter number of assignment:
        </div>
        <div class="form-group row">
          <div class="col-8">
            <input
              type="number"
              class="form-control"
              v-model="inputNumAssign"
            />
          </div>
          <div class="col-4">
            <button
              type="button"
              class="btn btn-outline-dark"
              @click="
                localEventHandler('click-assign-modal-ok', {
                  tester: testers[states.selectTester]
                })
              "
            >
              OK
            </button>
          </div>
        </div>
      </div>
    </modal>
    <!-- modal: profile -->
    <modal
      v-if="testers != null && testers[states.selectTester] != null"
      id="profile-modal"
      :title="
        'Tests assigned to ' +
          testers[states.selectTester].name +
          '(' +
          testers[states.selectTester].id +
          ')'
      "
      showBodyYScroll="true"
      bodyMaxHeight="60vh"
      margintop="10%"
      size="lg"
    >
      <template
        v-if="
          testers[states.selectTester].assignedTests != null &&
            testers[states.selectTester].assignedTests.length > 0
        "
      >
        <div class="container-fluid">
          <table class="table">
            <thead class="thead-dark">
              <tr>
                <th class="w-25">Name</th>
                <th class="w-25">Action</th>
                <th class="w-25">Done?</th>
                <th class="w-25">Assign date</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="t in testers[states.selectTester].assignedTests"
                :key="t.id"
              >
                <td>Test {{ t.id }}</td>
                <td>
                  <span
                    class="clickable"
                    @click="localEventHandler('action-unassign', { test: t })"
                  >
                    <i class="fa fa-ban" aria-hidden="true" /> Unassign
                  </span>
                </td>
                <td>
                  {{ t.numSubmittedSequence == t.numSequence }}
                </td>
                <td>
                  {{ t.assignDate }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </template>
      <template v-else>
        <div class="row">No test assigned.</div>
      </template>
    </modal>
    <!-- content -->
    <div class="container">
      <div class="row m-2">
        <div class="col-12">
          <button
            :class="{
              btn: true,
              'float-right': true,
              'm-2': true,
              'btn-outline-secondary': !states.showAllUsers,
              'btn-primary': states.showAllUsers
            }"
            @click="localEventHandler('click-show-all-users')"
          >
            Show hidden users
          </button>
        </div>
        <div class="col-12">
          <table class="table">
            <thead class="thead-dark">
              <tr>
                <th class="w-25">
                  Name
                </th>
                <th class="w-25">Actions</th>
                <th class="w-25">
                  <small><b>Done/Assigned</b></small>
                </th>
              </tr>
            </thead>
            <tbody>
              <template v-for="(t, i) in testers">
                <tr
                  v-if="
                    states.showAllUsers || hiddenUserIds.indexOf(t.id) == -1
                  "
                  :key="t.id"
                >
                  <td>
                    <span
                      class="clickable"
                      @click="
                        localEventHandler('click-edit-name', {
                          tester: t,
                          i: i
                        })
                      "
                    >
                      <i class="fa fa-pencil" aria-hidden="true" />
                    </span>
                    <i
                      v-if="hiddenUserIds.indexOf(t.id) != -1"
                      class="fa fa-eye-slash mx-1"
                    />
                    {{ t.name }} ({{ t.id }})
                  </td>
                  <td>
                    <span
                      class="m-1 clickable"
                      @click="
                        localEventHandler('action-tests', { tester: t, i: i })
                      "
                    >
                      <i class="fa fa-address-card" aria-hidden="true" /> Tests
                    </span>
                    <span
                      class="m-1 clickable"
                      @click="
                        localEventHandler('action-assign', { tester: t, i: i })
                      "
                    >
                      <i class="fa fa-plus-square-o" aria-hidden="true" />
                      Assign
                    </span>
                    <span
                      v-if="
                        states.showAllUsers && hiddenUserIds.indexOf(t.id) == -1
                      "
                      class="m-1 clickable"
                      @click="
                        localEventHandler('action-hide', { tester: t, i: i })
                      "
                    >
                      <i class="fa fa-eye-slash" aria-hidden="true" /> Hide
                    </span>
                    <span
                      v-else-if="states.showAllUsers"
                      class="m-1 clickable"
                      @click="
                        localEventHandler('action-unhide', { tester: t, i: i })
                      "
                    >
                      <i class="fa fa-eye" aria-hidden="true" /> Show
                    </span>
                  </td>
                  <td>
                    {{
                      t.assignedTests.filter(
                        x => x.numSequence == x.numSubmittedSequence
                      ).length
                    }}
                    / {{ t.assignedTests.length }}
                  </td>
                </tr>
              </template>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api_admin from '@/api/api_admin'
import Modal from '@/components/Modal.vue'
export default {
  name: 'AdminHome',
  data () {
    return {
      tests: [],
      testers: [],
      states: {
        batchId: null,
        testerId: null,
        selectTester: 0,
        loading: false,
        showAllUsers: false
      },
      hiddenUserIds: [],
      inputNumAssign: 1,
      inputUserName: ''
    }
  },
  components: {
    modal: Modal
  },
  created () {
    this.states.batchId = sessionStorage.batchId
    this.hiddenUserIds = localStorage.hiddenUserIds
      ? JSON.parse(localStorage.hiddenUserIds)
      : []
    localStorage.hiddenUserIds = JSON.stringify(this.hiddenUserIds)
    this.fetchTests()
    this.fetchTesters()
  },
  methods: {
    localEventHandler (name, event) {
      if (this.states.loading) {
        return
      }
      if (name == 'action-tests') {
        this.states.selectTester = event.i
        $('#profile-modal').modal('show')
      } else if (name == 'action-assign') {
        this.states.selectTester = event.i
        $('#assign-modal').modal('show')
      } else if (name == 'action-unassign') {
        this.states.loading = true
        api_admin.unassign_test(event.test.id).then(res => {
          this.states.loading = false
          if (res.success) {
            this.fetchTests()
            this.fetchTesters()
            $.notify('Unassign successfully.', {
              className: 'success',
              globalPosition: 'top center'
            })
          } else {
            $.notify('Failed: ' + res.message, {
              className: 'error',
              globalPosition: 'top center'
            })
          }
        })
      } else if (name == 'action-hide') {
        this.hiddenUserIds.push(event.tester.id)
        localStorage.hiddenUserIds = JSON.stringify(this.hiddenUserIds)
        this.$forceUpdate()
      } else if (name == 'action-unhide') {
        this.hiddenUserIds.splice(
          0,
          this.hiddenUserIds.length,
          this.hiddenUserIds.filter(x => x != event.tester.id)
        )
        localStorage.hiddenUserIds = JSON.stringify(this.hiddenUserIds)
        this.$forceUpdate()
      } else if (name == 'click-show-all-users') {
        this.states.showAllUsers = !this.states.showAllUsers
        this.$forceUpdate()
      } else if (name == 'click-assign-modal-ok') {
        this.states.loading = true
        $('#assign-modal').modal('hide')
        api_admin
          .assign_some_test(event.tester.id, parseInt(this.inputNumAssign))
          .then(res => {
            this.states.loading = false
            if (res.success) {
              $.notify(
                // prettier-ignore
                'Assigned ' + res.numAssigned + ' tests to '+event.tester.name + '(' + event.tester.id +')',
                { className: 'success', globalPosition: 'top center' }
              )
              this.fetchTests()
              this.fetchTesters()
            } else {
              $.notify('Failed: ' + res.message, {
                className: 'error',
                globalPosition: 'top center'
              })
            }
          })
      } else if (name == 'click-edit-name') {
        this.inputUserName = ''
        this.states.selectTester = event.i
        $('#change-name-modal').modal('show')
      } else if (name == 'click-change-name-ok') {
        $('#change-name-modal').modal('hide')
        api_admin
          .update_tester_name(event.tester.id, this.inputUserName)
          .then(res => {
            if (res.success) {
              $.notify(
                // prettier-ignore
                'Change name successfully.',
                { className: 'success', globalPosition: 'top center' }
              )
              var i = this.testers.findIndex(x => x.id == event.tester.id)
              this.testers[i].name = this.inputUserName
              this.$forceUpdate()
            } else {
              $.notify(
                // prettier-ignore
                'Failed: '+ res.message,
                { className: 'error', globalPosition: 'top center' }
              )
            }
          })
      }
    },
    fetchTests () {
      this.states.loading = true
      return api_admin.get_tests_by_batch(this.states.batchId).then(t => {
        this.tests = t
        this.states.loading = false
      })
    },
    fetchTesters () {
      this.states.loading = true
      api_admin.get_testers(this.states.batchId).then(t => {
        t.sort((a, b) => a.name.localeCompare(b.name))
        t.map(x => {
          if (x.assignedTests) {
            x.assignedTests.sort((a, b) => Number(b.id) - Number(a.id))
          }
        })
        this.testers = t
        this.states.loading = false
      })
    }
  }
}
</script>
<style scoped>
.clickable {
  cursor: pointer;
}
</style>
